class CategoryScroller {
    constructor() {
        this.main = document.getElementById("js-collection-categories");
        this.container = this.main.querySelector(".js-collection-categories-container");
        this.list = this.main.querySelector(".js-collection-categories-list");
        this.prevButton = this.main.querySelector(".js-collection-categories-prev");
        this.nextButton = this.main.querySelector(".js-collection-categories-next");

        if (!this.container || !this.list || !this.prevButton || !this.nextButton) return;
        
        this.init();
    }

    init() {
        this.checkScrollability();
        this.bindEvents();
    }

    bindEvents() {
        // Check scrollability on window resize
        window.addEventListener('resize', () => this.checkScrollability());
        
        // Update button states on scroll
        this.container.addEventListener('scroll', () => this.updateButtonStates());
        
        // Button click handlers
        this.prevButton.addEventListener('click', () => {
            this.scroll('left');
            console.log("scroll left");
        });
        this.nextButton.addEventListener('click', () => {
            this.scroll('right');
            console.log("scroll right");
        });
    }

    checkScrollability() {
        const isScrollable = this.list.scrollWidth > this.container.clientWidth;
        
        if (isScrollable) {
            this.container.classList.add('is-scrollable');
            this.prevButton.classList.remove('hidden');
            this.nextButton.classList.remove('hidden');
            this.updateButtonStates();
            console.log("is scrollable");
        } else {
            this.container.classList.remove('is-scrollable');
            this.prevButton.classList.add('hidden');
            this.nextButton.classList.add('hidden');
            console.log("not scrollable");
        }
    }

    updateButtonStates() {
        console.log("updateButtonStates");
        const scrollLeft = this.container.scrollLeft;
        const maxScroll = this.list.scrollWidth - this.container.clientWidth;
        
        this.prevButton.classList.toggle('is-visible', scrollLeft > 0);
        this.nextButton.classList.toggle('is-visible', scrollLeft < maxScroll);
    }

    scroll(direction) {
        const scrollAmount = this.container.clientWidth * 0.8;
        const currentScroll = this.container.scrollLeft;
        
        this.container.scrollTo({
            left: direction === 'left' 
                ? currentScroll - scrollAmount 
                : currentScroll + scrollAmount,
            behavior: 'smooth'
        });
    }
}

// Initialize on document ready
new CategoryScroller();